/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateLocationV1Dto = {
  /**
   * The current version of the entity
   */
  version: number;
  /**
   * The name of the location.
   */
  name: string;
  /**
   * The description of the location.
   */
  propertyDescription?: string | null;
  /**
   * The total area of the location in square meters.
   */
  totalArea?: number | null;
  /**
   * The start date of the location.
   */
  startDate?: string | null;
  /**
   * The type of the location.
   */
  type?: UpdateLocationV1Dto.type | null;
};
export namespace UpdateLocationV1Dto {
  /**
   * The type of the location.
   */
  export enum type {
    COMMERCIAL_CENTRE = 'CommercialCentre',
    OUTLET = 'Outlet',
    OFFICE_BUILDING = 'OfficeBuilding',
    STANDALONE = 'Standalone',
    RETAIL_CENTER = 'RetailCenter',
    OTHER = 'Other',
    COMMERCIAL_BUILDING = 'CommercialBuilding',
    MEDICAL_FACILITY = 'MedicalFacility',
  }
}
